import { useState } from 'react';

const faqs = [

  // 🌼 Flower Pot Related FAQs
  {
    question: 'Where can you buy the best planters (pots)?',
    answer: 'You can buy the best planters(pots) online from Durapot! We also offer plant and planter together, in single styles and even seeds!',
  },
  {
    question: 'Which would be the best ceramic pots for plants?',
    answer: 'The best ceramic pots for plants depend on the type of plant – how much water it would require, how tall it will grow etc. If you are too confused about which ceramic pot planter is right for you, explore our website or chat with us on Whatsapp.',
  },
  {
    question: 'Where do we get unique pots and plants Online?',
    answer: 'You will get the most unique pots and plants online on Durapot. As we source our items from top manufacturers in India, every time you explore our website, you will discover a never-seen-before variety at unbelievable prices.',
  },
];


const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold mb-6 text-center">FAQs</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-300">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full text-left flex justify-between items-center py-4"
            >
              <span className="text-lg font-semibold">{faq.question}</span>
              <span className="text-xl">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="pb-4 pl-2 text-gray-700">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
